<!--产业报告-->
<template>
<div class="site-content">
  <div class="site-content-banner">
    <img src="./../../assets/cybg_banner.png"/>
  </div>
  <div class="site-content-page width-per-100">
    <div class="content-row">
      <div class="content-col">
        <searchPageList-01  title="产业报告"  label="LAST NEWS" count="12" :infoBlock="infoBlock" :infoPage="infoPage" :tabList="tabList" :tabDefaultType="tabDefaultType" v-on:queryPage="cybg_Req"/>
      </div>
    </div>
    <div class="content-row">
      <div class="content-col">
        <a href="#">
          <img src="./../../assets/cybg_gg_1.png" width="1024px" style="margin-bottom:100px"/>
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoList01 from '../block/InfoList01'
import ImgLink03 from '../block/ImgLink03'
import SearchPageList01 from '../block/SearchPageList01'
import InfoBlock01 from '../block/InfoBlock01'
export default {
  name: 'Report01',
  components: {
    'searchPageList-01': SearchPageList01,
    'imgLink-03': ImgLink03
  },
  data () {
    return {
      infoBlock: InfoBlock01,
      infoPage: {},
      tabList: [{title: '云果研报', type: 'self_report'}, {title: '产业报告', type: 'third_part_report'}, {title: '券商研报', type: 'investment_report'}],
      tabDefaultType: 'self_report'
    }
  },
  methods: {
    // 产业报告
    cybg_Req (params) {
      let that = this
      params.type = ''
      params.p = params.page
      let result = {page: params, list: []}
      console.log('父页面查询参数：', params)
      that.$dataApi.reportLists({
        param: params
      }).then(res => {
        // console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg = res.msg
        result.list = res.data.list
        result.page.total = res.data.count
        that.infoPage = result
        console.log('结束请求Vue-axios：', result)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.width-per-100{
  width:100%;
}
.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Report01.vue